






























import Vue from 'vue';
import VueCompositionAPI, {
  ref,
  defineComponent,
  computed,
} from '@vue/composition-api';
import { LatLng, LocationValue, Hospital } from '@/store/types';
import axios from 'axios';
import {
  saveLocation,
  saveCity,
  getCity,
  getHospitalsFromBackend,
  getHospitals,
} from '../store';
import { useRouter, RouterAliases } from '../router';
// @ts-ignore
import Spinner from '@/components/spinner.vue';
import BackBtn from '@/components/back-btn.vue';
import HospitalSearch from '@/components/hostpital-search.vue';
Vue.use(VueCompositionAPI);

/* eslint-disable */
// @ts-ignore
window.gtag &&
  // @ts-ignore
  gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID, {
    page_path: `hospital-search`,
    app_name: 'Patients Care',
  });
/* eslint-enable */

function hospitalSearch() {
  //const loading = ref<boolean>(false);
  const hospitals = computed<Hospital[]>(() => getHospitals());
  const isSearchActive = ref<boolean>(false);

  // const home = () => {
  //   const router = useRouter();
  //   router.push({ name: RouterAliases.HOME });
  // };
  const onSearchActivated = () => {
    isSearchActive.value = true;
  };

  const onSearchDeactivated = (value: string) => {
    isSearchActive.value = Boolean(value);
  };

  return {
    hospitals,
    isSearchActive,
    onSearchActivated,
    onSearchDeactivated,
    // home
  };
}

const HospitalSearchComponent = defineComponent({
  components: {
    Spinner,
    BackBtn,
    HospitalSearch,
  },
  setup() {
    getHospitalsFromBackend();
    return {
      ...hospitalSearch(),
    };
  },
});

export default HospitalSearchComponent;
